(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  ns.OverlayView = Backbone.View.extend({
    el: "#overlay",
    name: "No Data Overlay",

    initialize: function() {
      var self = this;
      _.bindAll(this, "render");

      this.model.on("change", this.render);

      // Hide the legend text when a data update begins
      this.model.on("busy", function() {
        self.$el.hide();
      });
    },

    render: function() {
      this.$el.toggle(!this.model.hasData());
    }
  });
})(jQuery, _);
